// extracted by mini-css-extract-plugin
module.exports = {"page":"FastTrack_page__3gNuc","button":"FastTrack_button__rNfjt"};